<template>
  <b-container>
    <b-row class="justify-content-center align-items-center">
      <b-col class="col-sm-8 col-lg-4 col-md-6">
        <b-card class="shadow">
          <h1 class="text-center">Login</h1>

          <b-form @submit.prevent="login">
            <b-form-group>
              <b-form-input
                v-model="email"
                type="email"
                placeholder="Email"
                class="form-input mt-3"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="d-block">
              <b-form-input
                v-model="password"
                type="password"
                placeholder="Password"
                class="form-input mt-2"
                required
              ></b-form-input>
            </b-form-group>

            <b-button type="submit" variant="primary" class="mt-4 w-100 blue-gradient">Login</b-button>
          </b-form>

          <div class="border-bottom mt-2 mb-2"></div>

          <div class="text-right">
            <p>Not a member? <router-link to="/sign_up">Sign Up</router-link></p>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

export default {
  name: 'login',

  props: {
    success_message: {
      type: Boolean
    },
  },

  created() {
    if(this.success_message)
      this.$notify({
        type: 'success',
        text: 'Registered successfully!'
      })
  },

  data() {
    return {
      email: "",
      password: "",
    }
  },

  methods: {
    login() {
      this.$store.dispatch('create_session', {
        email: this.email,
        password: this.password
      })
        .then(response => {
          this.$router.push({ name: 'home' })
        })
        .catch(exception => {
          this.$notify({
            type: 'error',
            text: 'Invalid email or password!'
          })
        })
    },
  },

  beforeCreate: function() {
    document.body.className = 'login-image';
  },
}
</script>

<style scoped>
  .title {
    text-align: center;
    margin-top: 20px;
  }
  .form-input {
    border: 0;
    border-bottom: 1px solid;
  }
  .blue-gradient {
    background: linear-gradient(40deg, #979fff, #5663FF);
    border: 0;
  }
  .btn {
    height: 40px;
  }
  .row {
    height: 92vh;
  }
  .card {
    border-radius: 10px !important;
  }
</style>
